export const TITLE_MAX = 120;

export const validateStep1 = (values) => {
  const errors = {};
  if (!values.employeeId) errors.employeeId = 'required';
  if (!values.branchId) errors.branchId = 'required';
  return errors;
};

export const validateStep2 = (values) => {
  const errors = {};
  if (!values.categoryId) errors.categoryId = 'required';
  return errors;
};

export const validateStep3 = (values) => {
  const errors = {};
  if (!values.title || !values.title.trim()) errors.title = 'required';
  else if (values.title.length > TITLE_MAX) errors.title = 'too_long';
  if (!values.description || !values.description.trim()) errors.description = 'required';
  if (values.attachmentsUploading) errors.attachments = 'uploading';
  return errors;
};
